export interface ReturnAddressSession {
  roles?: string[];
  permissions?: string[];
  data?: { roles?: string[]; permissions?: string[] };
}
export interface ReturnAddressSessionState { userInfo: { value: ReturnAddressSession } }
export function canManageReturnAddress(session: ReturnAddressSession, action: string = "list"): boolean {
  const roles = session.roles ?? session.data?.roles ?? [];
  const permissions = session.permissions ?? session.data?.permissions ?? [];
  return !roles.includes("merchant") && (permissions.includes("*:*:*") || permissions.includes(`shop:returnAddress:${action}`));
}
